
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemDtGrid extends Serenity.EntityGrid<Adv05ItemDtRow, any> {
        protected getColumnsKey() { return Adv05ItemDtColumns.columnsKey; }
        protected getDialogType() { return Adv05ItemDtDialog; }
        protected getIdProperty() { return Adv05ItemDtRow.idProperty; }
        protected getInsertPermission() { return Adv05ItemDtRow.insertPermission; }
        protected getLocalTextPrefix() { return Adv05ItemDtRow.localTextPrefix; }
        protected getService() { return Adv05ItemDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 1000;
            return opt;
        }

        // protected createView(): Slick.RemoteView<TEntity> {
        //     let view = super.createView();
        //     (view as any).onDataLoaded.subscribe((e, ui) => {
        //         Q.notifyInfo('data loaded');
        //     });
        //     return view;
        // }//สำหรับขึ้น ว่าโหลดข้อมูลสำเร็จ

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Adv05ItemDtService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }
    }
}